// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3aOgX","content":"LoadingAlert_content__3TiKL"};